module.exports = __webpack_public_path__ + "images/adherence_background.webp";